module.exports = __webpack_public_path__ + "static/media/retailer.fa5c164b.svg";